import { differenceInYears } from 'date-fns';
import { Observable, of } from 'rxjs';
import { ViewModelService } from 'src/app/shared/view-model.service';
import { Gender } from 'src/graphql/generated/graphql.generated';
import { RequestViewModel } from 'src/models/request-view-model';
import {
  RequestPatientRecord,
  RequestPatientViewModelBase,
} from 'src/store/generated/request-patient-record.generated';
import { TransferReasonRecord } from 'src/store/generated/transfer-reason-record.generated';
import { formatDate } from 'src/util/date';
import { kilogramsToPounds, roundWeight } from 'src/util/units';

export class RequestPatientViewModel extends RequestPatientViewModelBase {
  public readonly name: string;
  public readonly transferReason$: Observable<TransferReasonRecord | undefined>;

  get weightString() {
    return this.weightInKg == null
      ? ''
      : `${kilogramsToPounds(this.weightInKg, 2)} lbs / ${roundWeight(this.weightInKg, 2)} kg`;
  }

  get ageGenderString() {
    const born =
      this.dateOfBirth == null ? null : `born ${formatDate(this.dateOfBirth, 'MM/dd/yyyy')}`;
    const age =
      this.dateOfBirth == null ? null : differenceInYears(new Date(Date.now()), this.dateOfBirth);
    const lifeStage =
      age == null ? null : age < 13 ? 'child' : age < 18 ? 'teen' : age < 65 ? 'adult' : 'elderly';
    const gender =
      this.gender === Gender.Unspecified ? null : `Gender: ${this.gender.toLocaleLowerCase()}`;
    const ageGender = [age == null ? null : `${age} y/o`, lifeStage, gender].join(' ').trim();
    return born == null ? ageGender : ageGender === '' ? '' : `${ageGender}, ${born}`;
  }

  get rideAlongAgeString() {
    const born =
      this.rideAlongDateOfBirth == null
        ? null
        : `born ${formatDate(this.rideAlongDateOfBirth, 'MM/dd/yyyy')}`;
    const age =
      this.rideAlongDateOfBirth == null
        ? null
        : differenceInYears(new Date(Date.now()), this.rideAlongDateOfBirth);
    return this.rideAlongDateOfBirth == null ? 'Unknown' : `${age}, ${born}`;
  }

  constructor(
    requestPatient: RequestPatientRecord,
    public readonly request: RequestViewModel,
    private _model: ViewModelService,
  ) {
    super(requestPatient);
    this.name = [this.firstName, this.lastName].join(' ').trim();

    this.transferReason$ =
      this.transferReasonId == null
        ? of(undefined)
        : this._model.transferReasons.getById(this.transferReasonId);
  }

  get rideAlongWeightString() {
    return this.rideAlongWeightInKg == null
      ? ''
      : `${kilogramsToPounds(this.rideAlongWeightInKg, 2)} lbs / ${roundWeight(
          this.rideAlongWeightInKg,
          2,
        )} kg`;
  }
}
